import React, { useMemo } from "react";
import { useMutation } from "react-query";
import { Link, useHistory } from "react-router-dom";

import useRemoteReviews from "../../../../../hooks/queryResults/remote/useRemoteReviews";
import useUrls from "../../../../../hooks/useUrls";
import http from "../../../../../services/httpService";
import Util from "../../../../../util/util";
import Table from "../../../../layout/Table";
import Loading from "../../../../ui/Loading";
import AdminRemoteReviewButton from "../../reviews/AdminRemoteReviewButton";

export default function AdminRemoteReviewsNflPlayers() {
  const history = useHistory();
  const { reviews, remoteReviewsQuery } = useRemoteReviews("NflPlayer");
  const { apiUrl } = useUrls();

  const finalDocType = "NflPlayer";

  const mutation = useMutation(
    (data) => {
      data.docType = "RemoteReview";
      const url = `${apiUrl}/admin/docs/${data.id}`;
      delete data.id;

      const config = Util.addTokenToHeaders();
      console.log(`sending request to url ${url} with data:`, data);
      return http.put(url, data, config);
    },
    {
      onSuccess: async () => {
        console.log(`review ${finalDocType} update - mutation success`);
      },
      onError: (error) => {
        console.error(error.response.data.error);
      },
    }
  );

  const reviewColumns = useMemo(
    () => [
      { Header: "Review", accessor: "reviewId" },
      { Header: "Site", accessor: "remoteSiteAbbr" },
      { Header: "Pos", accessor: "pos" },
      { Header: "First", accessor: "firstName", className: "left" },
      { Header: "Last", accessor: "lastName", className: "left" },
      { Header: "Team", accessor: "remoteNflFranchiseAbbr" },
      { Header: "Final", accessor: "finalDocsLength" },
      { Header: "Action", accessor: "action" },
      { Header: "Add", accessor: "add" },
      { Header: "Skip", accessor: "skip" },
      { Header: "Connect", accessor: "connect", className: "left" },
    ],
    []
  );

  const reviewData = useMemo(() => {
    const data = [];
    if (!reviews) return data;
    reviews.forEach((review) => {
      const doc = review.focusDoc;
      const numFinalDocs = review.finalDocs.length;
      const hasFinalDocs = numFinalDocs > 0;

      const canConnect = hasFinalDocs;
      const finalDoc = canConnect ? review.finalDocs[0] : null;
      const finalDocToConnectUrlId = canConnect ? finalDoc.id : null;
      const summary = canConnect
        ? `${finalDoc.pos}-${finalDoc.firstName} ${finalDoc.lastName}, ${finalDoc.nflFranchiseAbbr}`
        : null;
      const backgroundColor =
        canConnect &&
        doc.firstName === finalDoc.firstName &&
        doc.lastName === finalDoc.lastName
          ? "yellow"
          : "white";

      const row = {
        reviewId: (
          <Link to={`/admin/remote/reviews/NflPlayer/${review.id}`}>
            {review.id}
          </Link>
        ),
        remoteSiteAbbr: doc.remoteSiteAbbr,
        pos: doc.pos,
        firstName: doc.firstName,
        lastName: doc.lastName,
        remoteNflFranchiseAbbr: doc.remoteNflFranchiseAbbr,
        finalDocsLength: numFinalDocs,
        action: hasFinalDocs ? (
          <button
            className={"btn"}
            onClick={(e) => {
              e.preventDefault();
              history.push(`/admin/remote/reviews/NflPlayer/${review.id}`);
            }}
          >
            {review.action}
          </button>
        ) : null,
        add: !hasFinalDocs ? (
          <AdminRemoteReviewButton
            finalDocType={finalDocType}
            action={"add"}
            review={review}
          />
        ) : null,
        skip: !hasFinalDocs ? (
          <AdminRemoteReviewButton
            finalDocType={finalDocType}
            action={"skip"}
            review={review}
          />
        ) : null,
        connect: canConnect ? (
          <>
            <AdminRemoteReviewButton
              finalDocType={finalDocType}
              review={review}
              action={"update"}
              data={{ finalDocToConnectUrlId }}
            />
            <span style={{ backgroundColor }}>{summary}</span>
          </>
        ) : null,
      };

      data.push(row);
    });
    return data;
  }, [reviews, history]);

  const handleAddAll = async () => {
    console.log("handleAddAll called...");
    reviews.slice(0, 10).forEach((review) => {
      if (review.finalDocs.length === 0) {
        console.log(`adding review: ${review.id}...`);
        mutation.mutate({ id: review.id, action: "add" });
      }
    });
  };

  if (remoteReviewsQuery.isLoading) return <Loading />;

  return (
    <>
      <h1>
        <Link to={"/admin"}>Admin</Link> -{" "}
        <Link to={"/admin/remote/reviews"}>Remote Reviews</Link> - NflPlayers
      </h1>
      <button
        onClick={handleAddAll}
        className={"btn"}
        style={{ borderColor: "green", color: "green", margin: "0.5rem" }}
      >
        Add All
      </button>
      <Table columns={reviewColumns} data={reviewData} />
    </>
  );
}
